import { Navigate } from 'react-router';
import { Fingerprint, Link2, ShieldCheck } from 'lucide-react';
import { useMe } from '../api/queries';
import { Logo } from '../ui';
import { ThemeToggle } from '../app/ThemeToggle';
import { SignInActions } from './SignInActions';
import { homeFor } from './flow';
import { ChainArt } from './ChainArt';

export function SignInPage() {
  const me = useMe();
  if (me.data) return <Navigate to={homeFor(me.data.orgs)} replace />;

  return (
    <div className="signin">
      <aside className="signin__brand" aria-hidden="true">
        <div className="signin__brand-inner">
          <Logo size={30} />
          <ChainArt />
          <ul className="signin__points">
            <li>
              <Fingerprint /> Every file change becomes a signed fingerprint
            </li>
            <li>
              <Link2 /> Fingerprints are hash-chained and rolled into Merkle roots
            </li>
            <li>
              <ShieldCheck /> Roots are anchored on BSV, so anyone can verify
            </li>
          </ul>
        </div>
      </aside>

      <main id="main" className="signin__main">
        <div className="signin__top">
          <span className="signin__mobile-logo">
            <Logo />
          </span>
          <ThemeToggle />
        </div>
        <div className="signin__panel">
          <p className="signin__eyebrow">Tamper-evident security monitoring</p>
          <h1 className="signin__title">Prove what happened on your servers.</h1>
          <p className="signin__lede">
            CertiHash watches the files and logs that matter, seals every change into a signed hash chain, and anchors it on-chain,
            so any single event can be independently verified.
          </p>
          <div className="signin__actions">
            <SignInActions />
          </div>
        </div>
        <footer className="signin__foot subtle">
          By SmartLedger · <a href="https://smartledger.technology" target="_blank" rel="noreferrer noopener">smartledger.technology</a>
        </footer>
      </main>
    </div>
  );
}
